import AuthenticationUtil from '../../../../util/AuthenticationUtil';
import { usePrompt } from '../../../../util/PromptUtil';
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import BreadCrumb from '../../../../component/BreadCrumb';
import InputBox from '../../../../component/InputBox';
import SelectionBox from '../../../../component/SelectionBox';
import { CODE_GROUP_ID } from '../../../../constant/Constant';

import BoardPupupCheck from '../../../../component/BoardPupupCheck';
import DatePickerBox from '../../../../component/DatePickerBox';
import TextEditor from '../../../../component/editor/TextEditor';
import SingleFileAttachBox from '../../../../component/SingleFileAttachBox';
import {
    COMMUNITY_NOTICE_DETAIL_PATH,
    COMMUNITY_NOTICE_PATH,
    FILE_TYPE,
    PATH_DELIMITER,
    ROLE,
} from '../../../../constant/Constant';
import MultiFileAttachBox from '../../../../component/MultiFileAttachBox';
import CommunityPostEditorInfoBox from '../../../../component/CommunityPostEditorInfoBox';
import { actionEdit, actionDetail } from '../../../../module/body/community/notice/CommunityNoticeModule';
import { VIEW_COMMUNITY_NOTICE_EDIT } from '../../../../constant/ViewConstant';
import CancelButtonBox from '../../../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../../../component/buttons/ConfirmButtonBox';
import PopupRef from '../../../../component/PopupRef';
import CodeUtil from '../../../../util/CodeUtil';
import NullCheckUtil from '../../../../util/NullCheckUtil';

const CommunityNoticeEditView = () => {
    let params = useParams();

    // condition
    const [postingNo, setPostingNo] = useState(params && params.postingNo);
    const [postingTitleNm, setPostingTitleNm] = useState('');
    const [postingCtnt, setPostingCtnt] = useState('');
    const [universityNm, setUniversityNm] = useState('');
    const [noticeTypeCd, setNoticeTypeCd] = useState('');
    const [userNm, setUserNm] = useState('');
    const [regDttm, setRegDttm] = useState('');
    const [noticeBgnDt, setNoticeBgnDt] = useState('');
    const [noticeEndDt, setNoticeEndDt] = useState('');
    const [useStatusCd, setUseStatusCd] = useState('');

    const [noticeFileUid, setNoticeFileUid] = useState('');
    const [noticeFileNm, setNoticeFileNm] = useState('');
    const [noticeFile, setNoticeFile] = useState('');

    const [files, setFiles] = useState([]);
    const [fileIdx, setFileIdx] = useState(1);

    const [editPermission, setEditPermission] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isPopupNotice, setIsPopupNotice] = useState(false);

    const navigate = useNavigate();
    const popupRef = useRef(null);
    const dispatch = useDispatch();

    // 최초 초기화 호출
    useEffect(() => {
        window.scrollTo(0, 0);
        if (AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN) {
            setIsAdmin(true);
        }
        initSearch(params.postingNo);
    }, []);

    useEffect(() => {
        if (noticeTypeCd == 'POP-UP') {
            setIsPopupNotice(true);
        } else if (noticeTypeCd == 'NORMAL') {
            setIsPopupNotice(false);
        }
    }, [noticeTypeCd]);

    const initSearch = (postingNo) => {
        dispatch(
            actionDetail({
                params: { postingNo },
                callback: (result) => {
                    setDetail(result);
                },
            }),
        );
    };

    const setDetail = (result) => {
        setPostingTitleNm(result.postingTitleNm);
        setNoticeTypeCd(result.noticeTypeCd);
        setUserNm(result.userNm);
        setRegDttm(result.regDttm);
        setPostingCtnt(result.postingCtnt);
        setNoticeFileNm(result.noticeFileNm);
        setNoticeFileUid(result.noticeFileUid);
        setUseStatusCd(result.useStatusCd);

        if (NullCheckUtil.isNotEmpty(result.userUniversityCd)) {
            setUniversityNm(
                CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY).find((el) => el.cd == result.userUniversityCd).cdNm,
            );
        }
        if (NullCheckUtil.isNotEmpty(result.noticeBgnDt)) {
            let beginDt = result.noticeBgnDt;
            beginDt = beginDt.substring(0, 4) + '-' + beginDt.substring(4, 6) + '-' + beginDt.substring(6, 8);
            setNoticeBgnDt(beginDt);
        }
        if (NullCheckUtil.isNotEmpty(result.noticeEndDt)) {
            let endDt = result.noticeEndDt;
            endDt = endDt.substring(0, 4) + '-' + endDt.substring(4, 6) + '-' + endDt.substring(6, 8);
            setNoticeEndDt(endDt);
        }

        if (
            AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN ||
            (AuthenticationUtil.getUserRoleCd() == ROLE.STAFF && AuthenticationUtil.getUserId() == result.regUserId)
        ) {
            setEditPermission(true);
        } else {
            popupRef.current.openAlert(
                '공지사항 수정 권한이 부족합니다. 공지사항 목록 조회 화면으로 이동합니다.',
                () => {
                    return function () {
                        navigate(COMMUNITY_NOTICE_PATH);
                    };
                },
            );
        }

        let fileArr = [];
        result.files.forEach((file) => {
            fileArr.push({
                postingNo: file.postingNo,
                fileUid: file.fileUid,
                fileNm: file.fileNm,
                regDttm: file.regDttm,
                noticeTypeCd: file.noticeTypeCd,
            });
        });
        setFiles(fileArr);
    };

    // const auth = AuthenticationUtil.get();
    // usePrompt('현재 페이지를 벗어나시겠습니까?', true);

    const handleCancel = () => {
        var path = COMMUNITY_NOTICE_DETAIL_PATH + PATH_DELIMITER + postingNo;
        navigate(path);
    };

    const handleConfirm = () => {
        let bgnDt = '';
        let endDt = '';
        if (noticeBgnDt) {
            bgnDt = noticeBgnDt.replace(/-/gi, '');
        }
        if (noticeEndDt) {
            endDt = noticeEndDt.replace(/-/gi, '');
        }

        if (validateNotice() && validateNoticeFile()) {
            dispatch(
                actionEdit({
                    params: {
                        postingNo,
                        postingTitleNm,
                        postingCtnt,
                        noticeTypeCd,
                        noticeBgnDt: bgnDt,
                        noticeEndDt: endDt,
                        noticeFileUid,
                        useStatusCd,
                        files,
                    },
                    callback: (pno) => {
                        popupRef.current.openInfo('게시물 번호 ' + pno + '이 수정되었습니다.', () => {
                            return function () {
                                var path = COMMUNITY_NOTICE_DETAIL_PATH + PATH_DELIMITER + postingNo;
                                navigate(path);
                            };
                        });
                    },
                }),
            );
        }
    };

    const validateNotice = () => {
        console.log(editPermission);

        if (!editPermission) {
            popupRef.current.openAlert('로그인하신 사용자의 권한이 부족합니다.');
            return false;
        }
        if (NullCheckUtil.isEmpty(postingTitleNm)) {
            popupRef.current.openAlert('제목을 입력해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(postingCtnt)) {
            popupRef.current.openAlert('내용을 입력해주세요.');
            return false;
        }
        return true;
    };

    const validateNoticeFile = () => {
        if (noticeTypeCd == 'POP-UP') {
            if (NullCheckUtil.isEmpty(noticeBgnDt)) {
                popupRef.current.openAlert('팝업게시 시작일자를 선택해주세요.');
                return false;
            }
            if (NullCheckUtil.isEmpty(noticeEndDt)) {
                popupRef.current.openAlert('팝업게시 종료일자를 선택해주세요.');
                return false;
            }
            if (NullCheckUtil.isEmpty(noticeFileUid) && NullCheckUtil.isEmpty(noticeFile)) {
                popupRef.current.openAlert('팝업게시 이미지를 업로드 해주세요.');
                return false;
            }

            var beginDate = new Date(noticeBgnDt);
            var endDate = new Date(noticeEndDt);
            if (beginDate > endDate) {
                popupRef.current.openAlert('시작일자는 종료일자보다 이후 일 수 없습니다. 일자를 확인해주세요.');
                return false;
            }
        }
        return true;
    };

    const uploadFileHandler = (result) => {
        setFiles((arr) => [
            ...arr,
            {
                postingNo: params.postingNo,
                fileUid: result.fileUid,
                fileNm: result.fileNm,
                regDttm: result.regDttm,
                noticeTypeCd: 'NOTICE',
            },
        ]);
    };

    const fileDeleteHandler = (files) => {
        setFiles(files);
    };

    const onChangeFile = (result) => {
        setNoticeFileUid(result.fileUid);
        setNoticeFileNm(result.fileNm);
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg04'>
                    {/* <h2 className='con-title'>공지사항 게시물 편집</h2> */}
                    <h2 className='con-title'>{VIEW_COMMUNITY_NOTICE_EDIT.title}</h2>
                    <p className='con-title-p'>{VIEW_COMMUNITY_NOTICE_EDIT.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>

                <div className='community-wrap'>
                    <div className='cmnty-top-box'>
                        <div className='top-box-row full'>
                            <InputBox
                                title='제목'
                                value={postingTitleNm}
                                onChange={(e) => setPostingTitleNm(e.target.value)}
                            />
                            <SelectionBox
                                title='사용여부'
                                useAll={false}
                                value={useStatusCd}
                                w140
                                options={[
                                    { cd: 'ENABLED', cdNm: '사용' },
                                    { cd: 'DISABLED', cdNm: '미사용' },
                                ]}
                                onChange={(e) => setUseStatusCd(e.target.value)}
                            />
                        </div>
                        {isAdmin && (
                            <div className='top-box-row divide'>
                                <BoardPupupCheck
                                    title='팝업으로 게시'
                                    checked={noticeTypeCd == 'POP-UP'}
                                    onChecked={(e) => {
                                        e.target.checked ? setNoticeTypeCd('POP-UP') : setNoticeTypeCd('NORMAL');
                                    }}
                                />
                                {isPopupNotice && (
                                    <>
                                        <DatePickerBox
                                            title='팝업 시작일자'
                                            value={noticeBgnDt}
                                            size='large'
                                            onChange={(e) => setNoticeBgnDt(e.target.value)}
                                        />
                                        <DatePickerBox
                                            title='팝업 종료일자'
                                            value={noticeEndDt}
                                            size='large'
                                            onChange={(e) => setNoticeEndDt(e.target.value)}
                                        />

                                        <div className='w-634'>
                                            <SingleFileAttachBox
                                                labelName={'팝업이미지'}
                                                onChangeFile={(e) => onChangeFile(e)}
                                                fileUid={noticeFileUid}
                                                fileNm={noticeFileNm}
                                                editable={true}
                                                download={true}
                                                availableTypes={[
                                                    FILE_TYPE.PNG,
                                                    FILE_TYPE.JPG,
                                                    FILE_TYPE.JPEG,
                                                    FILE_TYPE.GIF,
                                                ]}
                                                fileTypeErrorMsg={
                                                    '파일형식이 맞지 않습니다. 팝업이미지는 PNG, JPG, JPEG, GIF 파일형식만 등록가능합니다.'
                                                }
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                    <TextEditor className='cmnty-wrt-box' value={postingCtnt} onChange={setPostingCtnt} />
                    <MultiFileAttachBox
                        className='cmnty-file-box'
                        uploadFileHandler={(e) => uploadFileHandler(e)}
                        files={files}
                        editable={true}
                        erasable={true}
                        fileDeleteHandler={(e) => fileDeleteHandler(e)}
                    />
                    <CommunityPostEditorInfoBox userNm={userNm} universityNm={universityNm} regDttm={regDttm} />
                    <div className='cmnty-btn-box btn-wrap'>
                        <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                        <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default CommunityNoticeEditView;
